module.exports = __webpack_public_path__ + "img/BM.a7277eac.png";